import React, { Component } from 'react';
import { Container, Row, Col, Table, Button, Badge, Alert } from 'react-bootstrap';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import { connect } from 'react-redux';
import { hideEnterpriseDeletedNotification } from '../../redux/modules/notifications';

const select = state => {
  return {
    token: state.auth.token,
    showNotification: state.notifications.showEnterpriseDeleted
  };
};

function mapDispatchToProps(dispatch) {
  return {
    hideEnterpriseDeletedNotification: () => dispatch(hideEnterpriseDeletedNotification())
  };
}

class ConnectedEnterprisesComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      enterprisesToValidate: [],
      enterprises: []
    };
  }

  async componentDidMount() {

    const { token } = this.props;
    
    const fetchValidatedEnterprises = fetch(`${apiUrl}/admin/enterprises?all=true&token=${token}`);
    const fetchEnterprisesToValidate = fetch(`${apiUrl}/admin/enterprises?token=${token}`);

    const respValidatedEnterprises = await fetchValidatedEnterprises;
    const respEnterprisesToValidate = await fetchEnterprisesToValidate;

    const dataValidatedEnterprises = await respValidatedEnterprises.json();
    const dataEnterprisesToValidate = await respEnterprisesToValidate.json();

    if (dataValidatedEnterprises.success && dataEnterprisesToValidate.success) {
      this.setState({
        enterprisesToValidate: dataEnterprisesToValidate.enterprises,
        enterprises: dataValidatedEnterprises.enterprises
      });
    }

    this.setState({ isLoading: false });

  }

  render() {

    const { enterprises, enterprisesToValidate, isLoading } = this.state;
    const { history, showNotification, hideEnterpriseDeletedNotification } = this.props;

    if (isLoading) return (<AppSpinner />);

    return (
      <div className="table-info-component enterprises-component">
        <Container>
          <Row>
            <Col xs={12}>
              {
                showNotification &&
                <Alert variant="info" onClose={hideEnterpriseDeletedNotification} dismissible>
                  <p>
                    El comercio se eliminó correctamente.
                  </p>
                </Alert>
              }

              <h2 className="header">Comercios</h2>
            </Col>

            <Col xs={12}>
              <h4 className="title">Comercios por validar</h4>

              {
                !enterprisesToValidate.length ? <p>No hay comercios por validar.</p> :
              
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nombre</th>
                      <th>Correo</th>
                      <th>Teléfono</th>
                      <th>Editar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      enterprisesToValidate.map((enterprise, index) =>
                        <tr key={enterprise._id}>
                          <td>{index + 1}</td>
                          <td>{enterprise.name}</td>
                          <td>{enterprise.email}</td>
                          <td>{enterprise.clientServiceNumber}</td>
                          <td>
                            <Button
                              variant="info"
                              size="sm"
                              onClick={() => {
                                history.push(`/comercios/${enterprise._id}`);
                              }}
                            >
                              Editar
                            </Button>
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
              }
              <hr />
            </Col>

            <Col xs={12}>
              <h4 className="title">Comercios validados</h4>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Teléfono</th>
                    <th>Estado</th>
                    <th>Editar</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    enterprises.map((enterprise, index) =>
                      <tr key={enterprise._id}>
                        <td>{index + 1}</td>
                        <td>{enterprise.name}</td>
                        <td>{enterprise.email}</td>
                        <td>{enterprise.clientServiceNumber}</td>
                        <td>
                          {
                            enterprise.validation === '2' ? <Badge variant="success">Validado</Badge> :
                            enterprise.validationDenied ? <Badge variant="danger">Rechazado</Badge> :
                            <Badge variant="secondary">Perfil incompleto</Badge>
                          }
                          
                        </td>
                        <td>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => {
                              history.push(`/comercios/${enterprise._id}`);
                            }}
                          >
                            Editar
                          </Button>
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const EnterprisesComponent = connect(select, mapDispatchToProps)(ConnectedEnterprisesComponent);

export default EnterprisesComponent;
